import { SettingOutlined } from '@ant-design/icons-vue'
export default [
  {
    path: '/system',
    name: 'system',
    redirect: '/system/config',
    meta: {
      title: '系统管理',
      sort: 6,
      icon: SettingOutlined,
      isFullScreen: false,
      keepAlive: true,
      hidden: false,
      prem: true,
    },
    children: [
      {
        path: '/system/config',
        name: 'systemConfig',
        component: () => import('@/views/system/config/index.vue'),
        meta: {
          title: '参数配置',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/system/news',
        name: 'systemNews',
        component: () => import('@/views/system/news/index.vue'),
        meta: {
          title: '资讯管理',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/system/operationLog',
        name: 'systemOperationLog',
        component: () => import('@/views/system/operationLog/index.vue'),
        meta: {
          title: '操作日志',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/system/loginLog',
        name: 'systemLoginLog',
        component: () => import('@/views/system/loginLog/index.vue'),
        meta: {
          title: '登录日志',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
